import * as React from 'react';
/**
 *
 * Original name: multiple folders
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=21780%3A2438
 *
 */
export const MultipleFoldersLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.5 7h4.386A2.25 2.25 0 0 1 8.9 8.245L9.276 9H18.5v9.25a2.25 2.25 0 0 1-2.25 2.25H4.75a2.25 2.25 0 0 1-2.25-2.25V7ZM4 8.5v9.75c0 .414.336.75.75.75h11.5a.75.75 0 0 0 .75-.75V10.5H8.349l-.792-1.585a.75.75 0 0 0-.67-.415H4Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 4h4.886A2.25 2.25 0 0 1 11.9 5.245l.377.755H21.5v9.25a2.25 2.25 0 0 1-1.5 2.122V7.5h-8.651l-.792-1.585a.75.75 0 0 0-.67-.415H5V4Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
